/* eslint-disable no-undef,handle-callback-err */
import { getNowTime } from './util'
import { post } from '@/assets/js/json'

const debug = process.env.NODE_ENV !== 'production'

/**
 * 获取手机gps信息（只能在真机上调试）
 */
export function getGps () {
  // let gps = {}
  return new Promise((resolve, reject) => {
    plus.geolocation.getCurrentPosition(function (p) {
      // alert(JSON.stringify(p))
      // gps.latitude = p.coords.latitude
      // gps.longitude = p.coords.longitude
      // gps.altitude = p.coords.altitude
      resolve(p)
    }, function (e) {
      reject(e)
    })
  })
}

export function showLoading (str) {
  plus.nativeUI.showWaiting(str)
}

export function closeLoading () {
  plus.nativeUI.closeWaiting()
}

/**
 * 手机拍照功能（只能在真机上进行调试）
 */
export function captureImage () {
  var cmr = plus.camera.getCamera()
  var res = cmr.supportedImageResolutions[0]
  var fmt = cmr.supportedImageFormats[0]
  return new Promise((resolve, reject) => {
    cmr.captureImage(function (path) {
      resolve(path)
    }, function (error) {
    }, {
      resolution: res,
      format: fmt
    })
  })
}

/**
 * 手机录像功能
 */
export function startVideoCapture () {
  var cmr = plus.camera.getCamera()
  var res = cmr.supportedImageResolutions[0]
  var fmt = cmr.supportedImageFormats[0]
  return new Promise((resolve, reject) => {
    cmr.startVideoCapture(function (path) {
      resolve('file://' + plus.io.convertLocalFileSystemURL(path))
    }, function (error) {
    }, {
      resolution: res,
      format: fmt
    })
  })
}

// export function startVideoCapture () {
//   return new Promise((resolve, reject) => {
//     plus.recordVideo.open(function (e) {
//       if (e.code === '000000') {
//         resolve(e.path)
//       } else {
//         reject(JSON.stringify(e))
//       }
//     })
//   })
// }

/**
 * 选择单张相片
 */
export function galleryImg () {
  // 从相册中选择图片
  return new Promise((resolve, reject) => {
    plus.gallery.pick(function (path) {
      resolve(path)
    }, function (e) {
      // alert(e)
    }, {
      filter: 'image'
    })
  })
}

export function getVideoSize (url) {
  return new Promise((resolve, reject) => {
    plus.io.resolveLocalFileSystemURL(url, function (entry) {
      entry.file(function (file) {
        const tmp = {}
        tmp.size = file.size / 1024 / 1024
        tmp.type = file.type
        resolve(tmp)
      })
    }, function (e) {
      reject(e)
    })
  })
}

/**
 * 保存相片到系统中
 */
export function saveImg (url) {
  return new Promise((resolve, reject) => {
    plus.gallery.save(url, function () {
      resolve({code: 1})
    }, function (e) {
      reject(e)
    })
  })
}

export function galleryMaximum (num) {
  return new Promise((resolve, reject) => {
    plus.gallery.pick(function (e) {
      resolve(e.files)
    }, function (e) {
      // console.log('取消选择图片')
    }, {
      filter: 'image',
      multiple: true,
      maximum: Number(num),
      system: false,
      onmaxed: function () {
        plus.nativeUI.alert('最大で9枚の写真が選べます', function() {
          console.log("User pressed!");
      }, "", "はい")
      }
    })
  })
}

export function galleryVideo () {
  return new Promise((resolve, reject) => {
    plus.gallery.pick(function (e) {
      resolve(e)
    }, function (e) {
      reject(e)
    }, {
      filter: 'video'
    })
  })
}

// export function galleryVideo () {
//   let recordVideo = plus.recordVideo
//   return new Promise((resolve, reject) => {
//     recordVideo.open(function (path) {
//       resolve(path)
//     })
//   })
// }

// 上传视频前视频压缩
export function compressVideo (path) {
  return new Promise((resolve, reject) => {
    let imgSuffix = path.substring(path.lastIndexOf('.') + 1, path.length)
    imgSuffix = imgSuffix.toLocaleLowerCase()
    let timestamp = getNowTime()
    let dstUrl = `_doc/${timestamp}-${Math.random()}.${imgSuffix}`
    plus.zip.compress(path, dstUrl, function (path) {
      resolve(path)
    })
  })
}

export function compressImage (file) {
  return new Promise((resolve, reject) => {
    let imgSuffix = file.substring(file.lastIndexOf('.') + 1, file.length)
    imgSuffix = imgSuffix.toLocaleLowerCase()
    let timestamp = getNowTime()
    let dstUrl = `_doc/${timestamp}-${Math.random()}.${imgSuffix}`
    plus.zip.compressImage({
      src: file,
      dst: dstUrl,
      quality: 40,
      format: 'jpg'
    }, function (e) {
      resolve(plus.io.convertLocalFileSystemURL(dstUrl))
    }, function (error) {
      reject(error)
    })
  })
}

// 获取版本号
export function getVersion () {
  return new Promise((resolve, reject) => {
    plus.runtime.getProperty(plus.runtime.appid, function (inf) {
      let wgtVer = inf.version
      resolve(wgtVer)
    })
  })
}

/**
 *陀螺仪
 */
export function getPlus () {
  return new Promise((resolve, reject) => {
    let phoneStatus = {}
    plus.accelerometer.getCurrentAcceleration(function (a) {
      phoneStatus.x1 = a.xAxis
      phoneStatus.y1 = a.yAxis
      phoneStatus.z1 = a.zAxis
      resolve(phoneStatus)
    })
  })
}

/**
 * 摄像功能
 */
export function videoCapture () {
  var cmr = plus.camera.getCamera()
  var res = cmr.supportedVideoResolutions[0]
  var fmt = cmr.supportedVideoFormats[0]
  return new Promise((resolve, reject) => {
    cmr.startVideoCapture(
      function (path) {
        resolve(plus.io.convertAbsoluteFileSystem(path))
      },
      function (error) {
        alert('Capture video failed: ' + error.message)
      }, {
        resolution: res,
        format: fmt
      }
    )
  })
}

/**
 * 设备震动
 */
export function vibrate () {
  if (!debug) {
    plus.device.vibrate(500)
  }
}

export function deletePush () {
  // if (!debug) {
  //   if (plus.push) {
  //     let msgList = plus.push.getAllMessage()
  //     if (msgList) {
  //       for (let i = 0; i < msgList.length; ++i) {
  //         plus.push.remove(msgList[i])
  //       }
  //     }
  //   }
  // }
}

/**
 * 跳转到设置
 */
export function gotoSetting () {
  if (plus.os.name === 'iOS') {
    plus.runtime.launchApplication({
      action: 'App-Prefs:root=INTERNET_TETHERING'
    }, function () {
    })
  }

  if (plus.os.name === 'Android') {
    var main = plus.android.runtimeMainActivity() // 获取activity
    var Intent = plus.android.importClass('android.content.Intent')
    var Settings = plus.android.importClass('android.provider.Settings')
    var intent = new Intent(Settings.ACTION_SETTINGS)// 可设置表中所有Action字段
    main.startActivity(intent)
  }
}

/**
 * 微信登陆获取服务
 */
export function getLoginService (service) {
  return new Promise((resolve, reject) => {
    // 扩展API加载完毕，现在可以正常调用扩展API
    plus.oauth.getServices(function (services) {
      console.log(services)
      let auths = services
      let s = null
      for (let i = 0; i < auths.length; ++i) {
        if (service === auths[i].id) {
          s = auths[i]
        }
      }
      s.login(function (e) {
        s.getUserInfo(function () {
          let userInfo
          userInfo = s.userInfo
          if (service === 'qq') {
            userInfo = Object.assign(userInfo, s.authResult)
          }
          s.logout()
          resolve(userInfo)
        }, function () {
          alert('获取用户信息失败')
        })
      }, function (e) {
        reject(e)
      })
    }, function (e) {
      reject(e)
    })
  })
}

/**
 * 获取分享服务
 */

export function getShareService (service, message) {
  return new Promise((resolve, reject) => {
    plus.share.getServices(function (s) {
      console.log(JSON.stringify(s))
      let shares = s
      let share = null
      for (let i = 0; i < shares.length; ++i) {
        if (shares[i].id === service) {
          share = shares[i]
        }
      }
      if(share == null){plus.nativeUI.toast('获取分享服务失败'); return ;}
      if (share.authenticated) {
        shareMessage(share, message)
      } else {
        share.authorize(function (s) {
          shareMessage(s, message)
        }, function (e) {
          alert('未进行认证')
          reject(e)
        })
      }
    }, function (e) {
      alert('获取分享服务列表失败：' + e.message)
      reject(e)
    })
  })
}

export function payment (payName, ordersId, transactionType) {
  // 获取支付通道
  return new Promise((resolve, reject) => {
    plus.payment.getChannels(function (channels) {
      const api = '/api/member/payment/pay/pre'
      const payType = {
        'wxpay': 'WECHAT',
        'alipay': 'ALIPAY'
      }
      let service = null
      for (let i = 0; i < channels.length; ++i) {
        if (channels[i].id === payName) {
          service = channels[i]
        }
      }
      if (service === null && !payServer[payName]) {
        const tmp = {errorMsg: '获取支付通道失败'}
        reject(tmp)
      } else {
        const option = {
          contentId: ordersId,
          payType: payType[payName],
          transactionType: transactionType || 'ORDERS'
        }
        console.log(JSON.stringify(option))
        post(api, option).then((res) => {
          console.log(JSON.stringify(res))
          if (res.data.success) {
            plus.payment.request(service, res.data.data, function (result) {
              const tmp = {
                success: true,
                msg: '支付成功'
              }
              resolve(tmp)
            }, function (error) {
              const tmp = {
                success: false,
                msg: '支付失败'
              }
              reject(tmp)
            })
          } else {
            const tmp = {
              msg: res.data.msg
            }
            reject(tmp)
          }
        })
      }
    }, function (e) {
      const tmp = {msg: '获取支付通道失败' + e.message}
      reject(tmp)
    })
  })
}

// 弹出键盘
export function showSoftInput () {
  let nativeWebview
  let imm
  let InputMethodManager
  if (plus.os.name === 'Android') {
    var main = plus.android.runtimeMainActivity()
    var Context = plus.android.importClass('android.content.Context')
    InputMethodManager = plus.android.importClass('android.view.inputmethod.InputMethodManager')
    imm = main.getSystemService(Context.INPUT_METHOD_SERVICE)
    imm.toggleSoftInput(0, InputMethodManager.SHOW_FORCED)
  } else {
    nativeWebview = plus.webview.currentWebview().nativeInstanceObject()
    nativeWebview.plusCallMethod({
      'setKeyboardDisplayRequiresUserAction': false
    })
  }
}

/**
 * 发送分享消息
 * @param {plus.share.ShareService} s
 */
function shareMessage (s, message) {//https://oss.xyzy.online/image/share_log.png
  console.log(s)
  message.thumbs = !message.thumbs ? ['http://livaia.oss-cn-hongkong.aliyuncs.com/image/658510c3-9cca-4aed-ad4a-aaf967cea49b.png'] : message.thumbs
  s.send(message, function () {
    message.callSuccessFunc ? message.callSuccessFunc() : plus.nativeUI.alert('シェアしました', function() {}, "", "はい")
  }, function (e) {
    console.log(JSON.stringify(e))
  })
}

/**
 * 打开新窗口
 * @param {plus.webview.create} 
 */
export function webView (url) {// https://oss.xyzy.online/image/share_log.png
  let w = plus.webview.create( url )
  w.show()
  // 获取所有Webview窗口
	var wvs=plus.webview.all();
	for (var i=0;i<wvs.length;i++) {
		console.log('webview'+i+': '+wvs[i].getURL());
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/native.js